// Under-construction toggle.
//
// Live hosts show the Under Construction screen while the studio's look & feel
// is being redesigned. The Emergent preview ALWAYS shows the full site so work
// can continue. To restore the full site on the live domain:
//   1. Set LIVE_UNDER_CONSTRUCTION = false below
//   2. Redeploy (same slot, free)
// You can also force the screen anywhere with REACT_APP_MAINTENANCE_MODE=true.

const LIVE_UNDER_CONSTRUCTION = true;

const LIVE_HOSTS = [
  "bluegreenstudio.in",
  "www.bluegreenstudio.in",
  "architect-connect-11.emergent.host",
];

export const isMaintenanceMode = () => {
  if (process.env.REACT_APP_MAINTENANCE_MODE === "true") return true;
  if (typeof window === "undefined") return false;
  return LIVE_UNDER_CONSTRUCTION && LIVE_HOSTS.includes(window.location.hostname);
};
